import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { SmoothScroll } from './components/SmoothScroll';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Methodology } from './components/Methodology';
import { Levels } from './components/Levels';
import { Pricing } from './components/Pricing';
import { Booking } from './components/Booking';
import { Resources } from './components/Resources';
import { Podcast } from './components/Podcast';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { AnalyticsTracker } from './components/AnalyticsTracker';
import Seo from './components/Seo';
import ExitIntentPopup from './components/ExitIntentPopup';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import ReschedulePage from './pages/ReschedulePage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import LevelLandingPage from './pages/LevelLandingPage';
import CaminoInfografiaPage from './pages/CaminoInfografiaPage';
import TestDeNivelPage from './pages/TestDeNivelPage';
import RecursoRefranesPage from './pages/RecursoRefranesPage';
import MiPackPage from './pages/MiPackPage';
import ReviewFormPage from './pages/ReviewFormPage';
import ReviewsPage from './pages/ReviewsPage';
import { ScrollToTop } from './components/ScrollToTop';
import { HomeIntro } from './components/HomeIntro';
import { HomeAudience } from './components/HomeAudience';
import { HomeFaq } from './components/HomeFaq';
import { HomeServiceCards } from './components/HomeServiceCards';
import ServiceLandingPage from './pages/ServiceLandingPage';
import { LANDINGS, HOME_PATHS, hreflangFor } from './config/landings';
import { useLanguage } from './context/LanguageContext';
import VocabularioHubPage from './pages/VocabularioHubPage';
import VocabularioTemaPage from './pages/VocabularioTemaPage';

const LandingPage = () => {
  const { language } = useLanguage();
  const path = HOME_PATHS[language] || '/';
  return (
  <SmoothScroll>
    <Seo path={path} hreflang={hreflangFor(path)} />
    <div className="App">
      <Navigation />
      <Hero />
      <Testimonials />
      <HomeIntro />
      <Methodology />
      <Booking />
      <About />
      <HomeServiceCards />
      <HomeAudience />
      <Pricing />
      <Levels />
      <Resources />
      <Podcast />
      <HomeFaq />
      <Footer />
      <WhatsAppButton />
      <ExitIntentPopup />
    </div>
  </SmoothScroll>
  );
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <LanguageProvider>
            <ScrollToTop />
            <AnalyticsTracker />
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/de" element={<LandingPage />} />
              <Route path="/en" element={<LandingPage />} />
              {LANDINGS.map((l) => (
                <Route key={l.path} path={l.path} element={<ServiceLandingPage path={l.path} />} />
              ))}
              <Route path="/espanol-a1" element={<LevelLandingPage slug="espanol-a1" />} />
              <Route path="/espanol-a2" element={<LevelLandingPage slug="espanol-a2" />} />
              <Route path="/espanol-b1" element={<LevelLandingPage slug="espanol-b1" />} />
              <Route path="/espanol-b2" element={<LevelLandingPage slug="espanol-b2" />} />
              <Route path="/espanol-c1-c2" element={<LevelLandingPage slug="espanol-c1-c2" />} />
              <Route path="/preparacion-dele" element={<LevelLandingPage slug="preparacion-dele" />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/camino/:slug" element={<CaminoInfografiaPage />} />
              <Route path="/test-de-nivel" element={<TestDeNivelPage />} />
              <Route path="/recursos/refranes-dichos-populares-espanoles" element={<RecursoRefranesPage />} />
              <Route path="/recursos/vocabulario-espanol" element={<VocabularioHubPage />} />
              <Route path="/recursos/vocabulario/:slug" element={<VocabularioTemaPage />} />
              <Route path="/reprogramar/:token" element={<ReschedulePage />} />
              <Route path="/mi-pack/:token" element={<MiPackPage />} />
              <Route path="/opinion/:token" element={<ReviewFormPage />} />
              <Route path="/opiniones" element={<ReviewsPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminPanel />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </LanguageProvider>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
